// MST - Filter keyboard accessibility fix
(function() {
  if (window.__globoFilterKeyboardA11yInit) return;
  window.__globoFilterKeyboardA11yInit = true;

  var titleSelector = '.gf-filter-contents .gf-block-title';
  var titleTextSelector = '.gf-block-title .h3, .gf-block-title h3';
  var blockActionSelector = '.gf-filter-contents a[onclick]:not([href])';
  var globalActionSelector = [
    '.globo-selected-items a[onclick]:not([href])',
    '.globo-dropdown-custom__options span[onclick]'
  ].join(', ');
  var filterOrder = ['metal', 'collection', 'type', 'gemstone', 'color'];
  var lastTabDirection = 'forward';
  var redirectingFocus = false;
  var filtersUnlocked = false;
  var treeStateObserver = null;

  function getFocusableElements(root) {
    return root ? root.querySelectorAll('a[href], a[onclick], button, input, select, textarea, [tabindex]') : [];
  }

  function syncHiddenFilterTree() {
    var filterTree = document.getElementById('gf-tree');
    if (!filterTree) return;

    var isHidden = filterTree.getAttribute('aria-hidden') === 'true';
    if (isHidden) {
      filterTree.setAttribute('inert', '');
    } else {
      filterTree.removeAttribute('inert');
    }

    getFocusableElements(filterTree).forEach(function(el) {
      if (isHidden) {
        if (!el.hasAttribute('data-gf-a11y-tabindex')) {
          el.setAttribute('data-gf-a11y-tabindex', el.getAttribute('tabindex') || '');
        }
        el.setAttribute('tabindex', '-1');
        return;
      }

      if (!el.hasAttribute('data-gf-a11y-tabindex')) return;
      var previousTabIndex = el.getAttribute('data-gf-a11y-tabindex');
      if (previousTabIndex === '') {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', previousTabIndex);
      }
      el.removeAttribute('data-gf-a11y-tabindex');
    });
  }

  function observeFilterTreeState() {
    var filterTree = document.getElementById('gf-tree');
    if (!filterTree) return;
    if (treeStateObserver) treeStateObserver.disconnect();

    treeStateObserver = new MutationObserver(function() {
      syncHiddenFilterTree();
    });

    treeStateObserver.observe(filterTree, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class']
    });
  }

  function getOptionBlock(el) {
    return el && el.closest('.gf-option-block');
  }

  function getBlockTitle(block) {
    return block && block.querySelector('.gf-block-title');
  }

  function getText(el) {
    return el && el.textContent ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function getFilterLabel(block) {
    return getText(block && block.querySelector(titleTextSelector)) || getText(getBlockTitle(block));
  }

  function closeOtherOptionBlocks(activeBlock) {
    document.querySelectorAll('.gf-option-block.gf-a11y-open').forEach(function(block) {
      if (block !== activeBlock) setOptionBlockOpen(block, false);
    });
  }

  function setOptionBlockOpen(block, isOpen) {
    if (!block) return;
    if (isOpen) closeOtherOptionBlocks(block);
    block.classList.toggle('gf-a11y-open', isOpen);
    var title = getBlockTitle(block);
    if (title) title.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    syncBlockActions(block, isOpen);
  }

  function syncBlockActions(block, isOpen) {
    if (!block) return;
    block.querySelectorAll(blockActionSelector).forEach(function(el) {
      el.setAttribute('tabindex', isOpen ? '0' : '-1');
      if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
    });
  }

  function enhanceFilterTitles(root) {
    (root || document).querySelectorAll(titleSelector).forEach(function(el) {
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'button');
      if (!el.hasAttribute('aria-expanded')) el.setAttribute('aria-expanded', 'false');
      el.querySelectorAll('.h3, h3').forEach(function(heading) {
        heading.removeAttribute('tabindex');
        heading.removeAttribute('role');
        heading.removeAttribute('aria-expanded');
        heading.removeAttribute('aria-label');
      });

      var label = getText(el.querySelector('.h3, h3')) || getText(el);
      if (label) el.setAttribute('aria-label', 'Filter - ' + label);
    });
  }

  function enhanceFilterActions(root) {
    (root || document).querySelectorAll(globalActionSelector).forEach(function(el) {
      el.setAttribute('tabindex', '0');
      if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
    });

    (root || document).querySelectorAll('.gf-option-block').forEach(function(block) {
      var filterLabel = getFilterLabel(block);
      block.querySelectorAll(blockActionSelector).forEach(function(el) {
        var optionLabel = el.getAttribute('title') || getText(el);
        if (filterLabel && optionLabel) {
          el.setAttribute('aria-label', 'Filter - ' + filterLabel + ' - ' + optionLabel);
        }
      });
      syncBlockActions(block, block.classList.contains('gf-a11y-open'));
    });
  }

  function getFilterOrderIndex(block) {
    var filterLabel = getFilterLabel(block).toLowerCase();
    var filterType = (block.getAttribute('data-filter-type') || '').toLowerCase();
    var index = filterOrder.findIndex(function(filterName) {
      return filterLabel === filterName ||
        filterType === filterName ||
        filterLabel.indexOf(filterName) !== -1 ||
        filterType.indexOf(filterName) !== -1;
    });

    return index === -1 ? Number.MAX_SAFE_INTEGER : index;
  }

  function getOrderedFilterBlocks(container) {
    var blocks = Array.prototype.slice.call(container.querySelectorAll('.gf-option-block'));

    return blocks.sort(function(a, b) {
      var orderDelta = getFilterOrderIndex(a) - getFilterOrderIndex(b);
      if (orderDelta !== 0) return orderDelta;
      return blocks.indexOf(a) - blocks.indexOf(b);
    });
  }

  function getFirstFilterTitle(container) {
    return getBlockTitle(getOrderedFilterBlocks(container)[0]);
  }

  function syncFilterTitleTabbability() {
    document.querySelectorAll('.gf-filter-contents-inner').forEach(function(container) {
      var firstTitle = getFirstFilterTitle(container);

      getOrderedFilterBlocks(container).forEach(function(block) {
        var title = getBlockTitle(block);
        if (!title) return;
        title.setAttribute('tabindex', filtersUnlocked || title === firstTitle ? '0' : '-1');
      });
    });
  }

  function unlockFilterTitles() {
    if (filtersUnlocked) return;
    filtersUnlocked = true;
    syncFilterTitleTabbability();
  }

  function syncFilterDomOrder() {
    document.querySelectorAll('.gf-filter-contents-inner').forEach(function(container) {
      var blocks = Array.prototype.slice.call(container.children).filter(function(el) {
        return el.classList && el.classList.contains('gf-option-block');
      });
      if (blocks.length < 2) return;

      var orderedBlocks = getOrderedFilterBlocks(container);

      var changed = orderedBlocks.some(function(block, index) {
        return block !== blocks[index];
      });

      if (!changed) return;
      orderedBlocks.forEach(function(block) {
        container.appendChild(block);
      });
    });
  }

  function redirectRestoredFilterFocus() {
    var titleTarget = document.activeElement && document.activeElement.closest && document.activeElement.closest(titleSelector);
    if (!titleTarget) return;

    var currentBlock = getOptionBlock(titleTarget);
    var container = currentBlock && currentBlock.closest('.gf-filter-contents-inner');
    if (!container) return;

    var orderedBlocks = getOrderedFilterBlocks(container);
    var targetBlock = lastTabDirection === 'backward' ? orderedBlocks[orderedBlocks.length - 1] : orderedBlocks[0];
    var targetTitle = getBlockTitle(targetBlock);
    if (!targetTitle || targetTitle === titleTarget) return;

    redirectingFocus = true;
    targetTitle.focus();
    redirectingFocus = false;
  }

  document.addEventListener('focusin', function(event) {
    if (redirectingFocus) return;

    var titleTarget = event.target.closest && event.target.closest(titleSelector);
    if (titleTarget) {
      var currentBlock = getOptionBlock(titleTarget);
      var container = currentBlock && currentBlock.closest('.gf-filter-contents-inner');
      var orderedBlocks = container ? getOrderedFilterBlocks(container) : [];
      var targetBlock = lastTabDirection === 'backward' ? orderedBlocks[orderedBlocks.length - 1] : orderedBlocks[0];
      var targetTitle = getBlockTitle(targetBlock);

      if (targetTitle && targetTitle !== titleTarget && container && !container.contains(event.relatedTarget)) {
        redirectingFocus = true;
        window.setTimeout(function() {
          targetTitle.focus();
          redirectingFocus = false;
        }, 0);
        return;
      }

      if (targetTitle && targetTitle === titleTarget) unlockFilterTitles();
    }

    var actionTarget = event.target.closest && event.target.closest(blockActionSelector);
    if (actionTarget) setOptionBlockOpen(getOptionBlock(actionTarget), true);
  });

  document.addEventListener('focusout', function(event) {
    var block = getOptionBlock(event.target);
    if (!block) return;

    window.setTimeout(function() {
      if (!block.contains(document.activeElement)) setOptionBlockOpen(block, false);
    }, 0);
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Tab') {
      lastTabDirection = event.shiftKey ? 'backward' : 'forward';
    }

    var titleTarget = event.target.closest && event.target.closest(titleSelector);
    if (titleTarget && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      var optionBlock = getOptionBlock(titleTarget);
      if (!optionBlock) return;
      setOptionBlockOpen(optionBlock, true);
      var firstFocusable = optionBlock.querySelector(blockActionSelector + ', input, select, button, textarea');
      if (firstFocusable) firstFocusable.focus();
      return;
    }

    if (titleTarget && event.key === 'ArrowDown') {
      var openedBlock = getOptionBlock(titleTarget);
      if (!openedBlock) return;
      event.preventDefault();
      setOptionBlockOpen(openedBlock, true);
      var firstFocusableOnArrow = openedBlock.querySelector(blockActionSelector + ', input, select, button, textarea');
      if (firstFocusableOnArrow) firstFocusableOnArrow.focus();
      return;
    }

    if ((titleTarget || (event.target.closest && event.target.closest(blockActionSelector))) && event.key === 'Escape') {
      var blockToClose = getOptionBlock(event.target);
      if (!blockToClose) return;
      event.preventDefault();
      setOptionBlockOpen(blockToClose, false);
      var blockTitle = getBlockTitle(blockToClose);
      if (blockTitle) blockTitle.focus();
      return;
    }

    var actionTarget = event.target.closest && event.target.closest(blockActionSelector + ', ' + globalActionSelector);
    if (!actionTarget) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();
    actionTarget.click();
  });

  document.addEventListener('click', function(event) {
    var titleTarget = event.target.closest && event.target.closest(titleSelector);
    if (titleTarget) {
      unlockFilterTitles();
      setOptionBlockOpen(getOptionBlock(titleTarget), true);
      window.setTimeout(syncHiddenFilterTree, 0);
      return;
    }

    if (!(event.target.closest && event.target.closest('.gf-option-block'))) {
      closeOtherOptionBlocks(null);
    }

    window.setTimeout(syncHiddenFilterTree, 0);
  });

  function enhanceGloboFilter(root) {
    syncFilterDomOrder();
    enhanceFilterTitles(root);
    enhanceFilterActions(root);
    syncFilterTitleTabbability();
    syncHiddenFilterTree();
    observeFilterTreeState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      enhanceGloboFilter(document);
      window.setTimeout(redirectRestoredFilterFocus, 0);
    });
  } else {
    enhanceGloboFilter(document);
    window.setTimeout(redirectRestoredFilterFocus, 0);
  }

  new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        enhanceGloboFilter(node);
      });
    });
  }).observe(document.body, {
    childList: true,
    subtree: true
  });

  window.addEventListener('load', function() {
    enhanceGloboFilter(document);
    window.setTimeout(redirectRestoredFilterFocus, 0);
  });

  window.addEventListener('pageshow', function() {
    enhanceGloboFilter(document);
    window.setTimeout(redirectRestoredFilterFocus, 0);
  });
})();
